import { Button } from "@mychili/clarity-ui";
import { cva } from "class-variance-authority";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PromoBannerDesktop } from "../../features/promo-banner";
import { analytics } from "../../shared/lib/analytics";
import { getImageSrcFromBase64 } from "../../shared/lib/get-image-src-form-base-64";
import { ROUTES } from "../../shared/routing/routing";

type PaymentViewDesktopProps = {
  orderAmount?: number;
  linkQr?: string;
  disallowPromocodes?: boolean;
  isWebFlowAllowed: boolean;
};

export const PaymentViewDesktop = ({
  linkQr,
  disallowPromocodes,
  isWebFlowAllowed,
}: PaymentViewDesktopProps) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const titleClass = cva("typography-headline-h3-medium text-center", {
    variants: {
      language: {
        en: "mx-10",
        ms: "mx-auto",
      },
    },
  });

  const handleContinueInBrowserClick = () => {
    analytics.log("PressContinueInBrowserButton", {
      platform: "desktop",
    });

    navigate(ROUTES.fakedoor);
  };

  useEffect(() => {
    if (isWebFlowAllowed) {
      analytics.log("ShowContinueInBrowserButton", {
        platform: "desktop",
      });
    }
  }, [isWebFlowAllowed]);

  return (
    <>
      <div className="flex max-h-3.5h-[419px] w-[464px] flex-col justify-between rounded-lg bg-background-neutral p-7">
        <h3 className={titleClass({ language: i18n.language as "en" | "ms" })}>
          {t("payment.desktop.title")}
        </h3>

        {linkQr ? (
          <img
            className="mx-auto mt-4 block h-[184px] w-[184px]"
            src={getImageSrcFromBase64(linkQr)}
            alt="qr"
          />
        ) : null}

        {isWebFlowAllowed && (
          <>
            <div className="my-5 flex items-center">
              <div className="h-px flex-1 bg-background-neutral-subtle"></div>
              <span className="typography-regular-text-regular whitespace-nowrap px-4 text-text-neutral-subtler">
                {/* @todo localize */}
                {t("fakedoor.desktop.button_separator_text")}
              </span>
              <div className="h-px flex-1 bg-background-neutral-subtle"></div>
            </div>

            <Button variant="primary" onClick={handleContinueInBrowserClick}>
              {t("payment.continue_button_text")}
            </Button>
          </>
        )}
      </div>
      {!disallowPromocodes && <PromoBannerDesktop />}
    </>
  );
};
